import JxForm from '../../../JxControls/JxForms/JxForm';
import jxWindowEngine from '../../../JxControls/JxWindowManager/JxWindowEngine';

// import '../../../JxControls/JxTheme.css';

/**
 * Dumb contract — all concrete card widgets extend this.
 */
class PainterBase extends JxForm {
    onPaint(state) {
        throw new Error('onPaint(state) must be implemented by subclass');
    }
}

export default PainterBase;
